module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 /* allowHtmlVariables value */ 
__p+='\n\n<div class="formField ';
 if (noSpacing) { 
__p+='formField-noMargin';
 } 
__p+='">\n    ';
 if (label) { 
__p+='\n        <label for="'+
((__t=( name ))==null?'':_.escape(__t))+
'">'+
((__t=( label ))==null?'':_.escape(__t))+
'</label>\n    ';
 } 
__p+='\n\n    <input class="t-text js-text formField__input"\n        value="'+
((__t=( value ))==null?'':_.escape(__t))+
'"\n        type="text"\n        id="'+
((__t=( name ))==null?'':_.escape(__t))+
'"\n        name="'+
((__t=( name ))==null?'':_.escape(__t))+
'"\n        placeholder="'+
((__t=( placeholder ))==null?'':_.escape(__t))+
'"\n        ';
 if (disabled) { 
__p+='disabled';
 } 
__p+='\n        ';
 if (minlength) { 
__p+='minlength="'+
((__t=( minlength ))==null?'':_.escape(__t))+
'"';
 } 
__p+='\n        ';
 if (maxlength) { 
__p+='maxlength="'+
((__t=( maxlength ))==null?'':_.escape(__t))+
'"';
 } 
__p+='\n        ';
 if (required) { 
__p+='required';
 } 
__p+='\n        data-hj-suppress />\n     <div class="js-control-error"></div>\n</div>\n';
}
return __p;
};
